
import getActions from '../../sagas/map';

export default function buttonCommandClick(dispatch, id, params, actionType) {
    const addCommand = getActions(dispatch, actionType).addCommand;
    addCommand(id, params);
}
